<template>
  <v-row class="add-client-form no-padding row-height">
    <div class="col-md-12">
      <successModal
        ref="success_modal"
        v-on:confirm="closeSuccessModal"
      ></successModal>
      <div class="row">
        <div class="col-md-12">
          <h3 class="form-title font ml-2">Account</h3>
        </div>
      </div>
      <div class="col-md-12 text-center justify-center" v-if="readyToShow">
        <v-progress-circular
          indeterminate
          :size="100"
          color="primary"
          class="text-center"
        ></v-progress-circular>
      </div>
      <v-form v-model.trim="valid" ref="form" class="row" v-else>
        <div class="col-md-6">
          <div class="col-md-12 pb-0">
            <label class="font text-gray" for="">Company Legal Name</label>
            <v-text-field
              required
              :rules="requiredRules"
              v-model.trim="companyName"
              solo
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for="">Company Display Name</label>
            <v-text-field
              required
              :rules="requiredRules"
              v-model.trim="displayName"
              solo
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for="">Tax ID</label>
            <v-text-field
              required
              @keyup="showSlash($event)"
              v-model.trim="taxId"
              placeholder="00-0000000"
              :rules="taxIdRules"
              counter="10"
              solo
              maxlength="10"
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for="">Website</label>
            <v-text-field required v-model.trim="website" solo></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for=""
              >Company Logo (Image Size - Width = 100px Height = 50px)</label
            >
            <div class="row mt-2">
              <div class="col-xl-10 col-md-9 col-xs-12 col-sm-12" cols="12">
                <v-file-input
                  @change="Preview_image"
                  v-model.trim="dataComponents.image"
                  required
                  solo
                  truncate-length="15"
                  ref="fileInput"
                ></v-file-input>
              </div>
              <div
                class="col-xl-2 col-md-3 col-xs-12 col-sm-12"
                v-if="$role != 'user'"
                cols="12"
              >
                <v-btn
                  class="blue-buttons col-sm-12"
                  @click="activateFileInput"
                  style="padding: 23px"
                >
                  Browse
                </v-btn>
              </div>
            </div>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for="">HQ Address Line 1</label>
            <v-text-field required v-model.trim="address1" solo></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for="">HQ Address Line 2</label>
            <v-text-field required v-model.trim="address2" solo></v-text-field>
          </div>
          <v-row class="no-padding">
            <div class="col-md-6 pb-0 pt-0">
              <label class="font text-gray" for="">City</label>
              <v-text-field required v-model.trim="city" solo></v-text-field>
            </div>
            <div class="col-md-3 pb-0 pt-0">
              <label class="font text-gray" for="">State</label>
              <v-select
                :items="states"
                item-text="name"
                item-value="name"
                required
                v-model.trim="state"
                solo
              ></v-select>
            </div>
            <div class="col-md-3 pb-0 pt-0">
              <label class="font text-gray" for="">Zip</label>
              <v-text-field
                required
                type="number"
                :rules="zip.length > 0 ? zipRules : []"
                v-model.trim="zip"
                solo
              ></v-text-field>
            </div>
          </v-row>
          <div class="col-md-12"></div>
        </div>
        <div class="col-md-6">
          <div class="col-md-12 pb-0">
            <label class="font text-gray" for=""
              >Approximate Number of Employees</label
            >
            <v-text-field
              required
              v-model.trim="numberOfEmp"
              solo
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for=""
              >Approximate Number of Plan Members</label
            >
            <v-text-field
              required
              v-model.trim="numberOfMembers"
              solo
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for=""
              >Current Network Vendor
              <i class="fas fa-question-circle yellow-icons"></i
            ></label>
            <v-text-field required v-model.trim="vendor" solo></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for=""
              >Current Network Discount Rate (i.e Precent Discount off Billed
              Charges) <i class="fas fa-question-circle yellow-icons"></i
            ></label>
            <v-text-field
              required
              v-model.trim="discountRate"
              solo
            ></v-text-field>
          </div>
          <div class="col-md-12 mt-6">
            <v-btn
              @click="generatePdf"
              large
              class="blue-buttons col-xl-7 col-md-11"
              >Access the Sample Plan Addendum</v-btn
            >
          </div>
          <div class="col-md-12 mt-6">
            <v-btn
              @click="generatePdf"
              large
              class="blue-buttons col-xl-7 col-md-11 blue-buttons-font-size"
              >Access the Apaly Health Terms of Use Agreement</v-btn
            >
          </div>
        </div>
        <div
          class="col-md-12 d-flex align-end flex-column"
          v-if="$role != 'user'"
        >
          <v-btn class="blue-buttons" @click="update"> Update & Save </v-btn>
        </div>
      </v-form>
    </div>
  </v-row>
</template>
<script>
import api from "../../../../../services/api";
import successModal from "../../../../TablesTemplate/SuccessDialog.vue";
export default {
  components: { successModal },
  data() {
    return {
      companyName: "",
      displayName: "",
      taxId: "",
      website: "",
      logo: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      updateLogo: false,
      dataComponents: {
        image: {
          name: "",
        },
      },
      numberOfEmp: "",
      numberOfMembers: "",
      vendor: "",
      states: [],
      discountRate: "",
      valid: false,
      requiredRules: [(v) => !!v || "This field is required"],
      zipRules: [
        (v) => (v && v.length == 5) || " Zip Code should be five digits long",
      ],
      readyToShow: false,
      imageEvent: null,
      taxIdRules: [
        (v) => !!v || "This field is required",
        (v) =>
          !!/[0-9]{2}\-[0-9]{7}/.test(v) ||
          "Tax ID should contain 9 digits, Please enter your Tax ID in XX-XXXXXXX format",
      ],
    };
  },
  computed: {
    singleEmp() {
      let provider = "";
      if (localStorage.getItem("employer")) {
        provider = JSON.parse(localStorage.getItem("employer"));
      }

      return provider;
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    generatePdf() {
      window.open("https://api.apaly.net/terms");
    },
    showSlash(event) {
      if (this.taxId.length == 2 && event.keyCode != 8) {
        this.taxId += "-";
      }
      if (this.taxId.length == 10) {
        api()
          .get("auth/isValidTaxId?taxId=" + this.taxId)
          .catch((res) => {
            if (res) {
              this.taxIdRules = [res.response.data.message];
            }
          });
      } else {
        this.taxIdRules = [
          (v) => !!v || "This field is required",
          (v) =>
            !!/[0-9]{2}\-[0-9]{7}/.test(v) ||
            "Tax ID should contain 9 digits, Please enter your Tax ID in XX-XXXXXXX format",
        ];
      }
    },
    activateFileInput() {
      this.$refs.fileInput.$refs.input.click();
    },
    getStates() {
      api()
        .get("/api/states")
        .then((res) => {
          res.data.forEach((el) => {
            if (el.active) {
              this.states.push(el);
            }
          });
        });
    },
    closeSuccessModal() {
      this.$refs.success_modal.closePopUp();
    },
    getInfo() {
      this.readyToShow = true;
      let user = JSON.parse(localStorage.getItem("user"));
      let advisorId = user.groupPortal[0].organization.employerAdvisor;
      let employer = JSON.parse(localStorage.getItem("employer"));
      api()
        .get(`/advisors/${advisorId}/employers/${employer._id}`)
        .then((res) => {
          if (res) {
            this.companyName = res.data.employer.companyName;
            this.displayName = res.data.employer.displayName
              ? res.data.employer.displayName
              : "";
            this.taxId = res.data.employer.taxId ? res.data.employer.taxId : "";
            this.vendor = res.data.employer.networkVendor
              ? res.data.employer.networkVendor
              : "";
            this.numberOfEmp = res.data.employer.noEmployees
              ? res.data.employer.noEmployees
              : "";
            this.numberOfMembers = res.data.employer.noPlanMembers
              ? res.data.employer.noPlanMembers
              : "";
            this.city = res.data.employer.city ? res.data.employer.city : "";
            this.state = res.data.employer.state ? res.data.employer.state : "";
            this.zip = res.data.employer.zipCode
              ? res.data.employer.zipCode
              : "";
            this.website = res.data.employer.website
              ? res.data.employer.website
              : "";
            this.address1 = res.data.employer.address1
              ? res.data.employer.address1
              : "";
            this.address2 = res.data.employer.address2
              ? res.data.employer.address2
              : "";
            this.discountRate = res.data.employer.networkDiscountRate
              ? res.data.employer.networkDiscountRate
              : "";
            this.dataComponents.image.name = res.data.employer.logo
              ? res.data.employer.logo
              : "";
          }
          this.readyToShow = false;

          this.getStates();
        });
    },
    update() {
      this.$refs.form.validate();
      if (this.valid) {
        let data = {
          networkVendor: this.vendor,
          companyName: this.companyName,
          displayName: this.displayName,
          taxId: this.taxId,
          website: this.website,
          address1: this.address1,
          address2: this.address2,
          city: this.city,
          state: this.state,
          zipCode: this.zip,
          noEmployees: this.numberOfEmp,
          noPlanMembers: this.numberOfMembers,
          networkDiscountRate: this.discountRate,
          companyLogo: this.imageEvent,
        };
        let formData = new FormData();
        formData.append("_method", "PUT");
        formData.append("image", this.imageEvent);

        let user = JSON.parse(localStorage.getItem("user"));
        let advisorId = user.groupPortal[0].organization.employerAdvisor;
        let employer = JSON.parse(localStorage.getItem("employer"));

        api()
          .put(`/advisors/${advisorId}/employers/${employer._id}`, data)
          .then((res) => {
            if (res) {
              if (this.imageEvent && this.updateLogo) {
                api()
                  .put(
                    `/advisors/${advisorId}/employers/${employer._id}/logo`,
                    formData
                  )
                  .then((res) => {
                    this.$refs.success_modal.openPopUp(
                      "Account updated successfully"
                    );
                  });
              } else if (this.imageEvent && this.updateLogo) {
                api()
                  .delete(
                    `/advisors/${advisorId}/employers/${employer._id}/logo`,
                    formData
                  )
                  .then((res) => {
                    this.$refs.success_modal.openPopUp(
                      "Account updated successfully"
                    );
                  });
              } else {
                this.$refs.success_modal.openPopUp(
                  "Account updated successfully"
                );
              }
            }
          });
      }
    },
    Preview_image(event) {
      this.updateLogo = true;
      this.imageEvent = event;
    },
  },
};
</script>